"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCachedEligibilityResults = exports.isReceivableResponseTape = exports.isArtifactDependencyRecord = exports.typeguardArrayFunctionLogWrapper = exports.typeguardFunctionLogWrapper = exports.typeguardFunctionWrapper = exports.reporting = exports.railz = exports.portfolioGeneratedLoanTape = exports.portfolioCovenant = exports.organization = exports.materializedView = exports.loanProduct = exports.loan = exports.insights = exports.fundingRequest = exports.finleyAi = exports.financialCovenant = exports.financialData = exports.explo = exports.deliverables = exports.date = exports.datalake = exports.creditAgreement = exports.borrowingBase = exports.datetime = exports.assetVerification = exports.assignment = void 0;
const jsonschema_1 = __importDefault(require("jsonschema"));
const schema = __importStar(require("../schema"));
const Log_1 = require("../types/Log");
exports.assignment = __importStar(require("./assignment"));
exports.assetVerification = __importStar(require("./assetVerification"));
exports.datetime = __importStar(require("./datetime"));
exports.borrowingBase = __importStar(require("./borrowingBase"));
exports.creditAgreement = __importStar(require("./creditAgreement"));
exports.datalake = __importStar(require("./datalake"));
exports.date = __importStar(require("./date"));
exports.deliverables = __importStar(require("./deliverables"));
exports.explo = __importStar(require("./explo"));
exports.financialData = __importStar(require("./financialData"));
exports.financialCovenant = __importStar(require("./financialCovenant"));
exports.finleyAi = __importStar(require("./finleyAi"));
exports.fundingRequest = __importStar(require("./fundingRequest"));
exports.insights = __importStar(require("./insights"));
exports.loan = __importStar(require("./loan"));
exports.loanProduct = __importStar(require("./loanProduct"));
exports.materializedView = __importStar(require("./materializedView"));
exports.organization = __importStar(require("./organization"));
exports.portfolioCovenant = __importStar(require("./portfolioCovenant"));
exports.portfolioGeneratedLoanTape = __importStar(require("./portfolioGeneratedLoanTape"));
exports.railz = __importStar(require("./railz"));
exports.reporting = __importStar(require("./reporting"));
__exportStar(require("./util"), exports);
var typeguardUtils_1 = require("./typeguardUtils");
Object.defineProperty(exports, "typeguardFunctionWrapper", { enumerable: true, get: function () { return typeguardUtils_1.typeguardFunctionWrapper; } });
Object.defineProperty(exports, "typeguardFunctionLogWrapper", { enumerable: true, get: function () { return typeguardUtils_1.typeguardFunctionLogWrapper; } });
Object.defineProperty(exports, "typeguardArrayFunctionLogWrapper", { enumerable: true, get: function () { return typeguardUtils_1.typeguardArrayFunctionLogWrapper; } });
const isArtifactDependencyRecord = (obj) => {
    const { created_at: _unusedCreatedAt, updated_at: _unusedUpdatedAt, ...remainingObj } = obj;
    const result = jsonschema_1.default.validate(remainingObj, schema.ArtifactDependencyRecordSchema);
    return result.valid;
};
exports.isArtifactDependencyRecord = isArtifactDependencyRecord;
const isReceivableResponseTape = (obj, logOptions) => {
    const result = jsonschema_1.default.validate(obj, schema.ReceivableResponseTapeSchema, {
        nestedErrors: true,
    });
    if (logOptions?.logger && result.errors.length > 0) {
        const error = {
            message: `Receivable Response Tape validation failed`,
            metadata: {
                logMeta: {
                    typeguard: 'isReceivableResponseTape',
                    validationErrors: result.errors.map((_error) => _error.stack),
                },
            },
        };
        logOptions.logger(error, logOptions.logLevel || Log_1.LogLevel.Error);
    }
    return result.valid;
};
exports.isReceivableResponseTape = isReceivableResponseTape;
const isCachedEligibilityResults = (obj, logOptions) => {
    const result = jsonschema_1.default.validate(obj, schema.ReceivableResponseTapePreviewEligibilityStatusesSchema, {
        nestedErrors: true,
    });
    if (logOptions?.logger && result.errors.length > 0) {
        const error = {
            message: `Receivable Response Tape Eligibility Statuses validation failed`,
            metadata: {
                logMeta: {
                    typeguard: 'isCachedEligibilityResults',
                    validationErrors: result.errors.map((_error) => _error.stack),
                },
            },
        };
        logOptions.logger(error, logOptions.logLevel || Log_1.LogLevel.Error);
    }
    return result.valid;
};
exports.isCachedEligibilityResults = isCachedEligibilityResults;
//# sourceMappingURL=index.js.map